module.exports = __webpack_public_path__ + "img/Images_Chrome.c1805b4d.svg";